var _style, _g, _defs, _path, _polygon, _defs2, _path2, _polygon2, _defs3, _path3, _polygon3, _polygon4, _polygon5, _path4, _polygon6, _polygon7, _polyline, _defs4, _line, _line2, _line3, _line4, _line5, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelfieldSpecLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#CCCCCC;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#CCCCCC;}\n\t.st6{clip-path:url(#SVGID_4_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#CCCCCC;}\n\t.st8{clip-path:url(#SVGID_6_);fill:#808080;}\n\t.st9{fill:#808080;}\n\t.st10{fill:#CCCCCC;}\n\t.st11{fill:#0AAEFF;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st14{clip-path:url(#SVGID_8_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st15{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M177.8,454c1.7,0.4,3.5,0.3,5.3-0.6c5.1-2.6,7.9-10.1,6.3-16.8c-1-4.3-3.6-7.3-6.7-8.2 c-3.1-0.9-8.4-2.2-10.1-2.7c-1.7-0.5-3.5-0.3-5.3,0.6c-5.1,2.6-7.9,10.1-6.3,16.8c1,4.4,3.6,7.3,6.7,8.2 C170.1,452,175.1,453.4,177.8,454z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171,445.8c-1.6-6.7,1.2-14.3,6.3-16.8c1.8-0.9,3.6-1.1,5.3-0.6c-3.1-0.9-8.4-2.2-10.1-2.7 c-1.7-0.5-3.5-0.3-5.3,0.6c-5.1,2.6-7.9,10.1-6.3,16.8c1,4.4,3.6,7.3,6.7,8.2c2.5,0.7,7.4,2.1,10.1,2.7 C174.7,453.1,172.1,450.2,171,445.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "154.7,430.7 176.9,436.9 191.3,431.5 184.7,420.6 155.4,422.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M252.1,473.9c1.7,0.4,3.5,0.3,5.3-0.6c5.1-2.6,7.9-10.1,6.3-16.8c-1-4.3-3.6-7.3-6.7-8.2 c-3.1-0.9-8.4-2.2-10.1-2.7c-1.7-0.5-3.5-0.3-5.3,0.6c-5.1,2.6-7.9,10.1-6.3,16.8c1,4.4,3.6,7.3,6.7,8.2 C244.5,471.9,249.4,473.3,252.1,473.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245.4,465.7c-1.6-6.7,1.2-14.3,6.3-16.8c1.8-0.9,3.6-1.1,5.3-0.6c-3.1-0.9-8.4-2.2-10.1-2.7 c-1.7-0.5-3.5-0.3-5.3,0.6c-5.1,2.6-7.9,10.1-6.3,16.8c1,4.4,3.6,7.3,6.7,8.2c2.5,0.7,7.4,2.1,10.1,2.7 C249,473,246.4,470.1,245.4,465.7z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "231,450.4 253.2,456.6 267.5,451.2 261,440.4 231.7,441.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M327.4,430.4c1.7,0.4,3.5,0.3,5.3-0.6c5.1-2.6,7.9-10.1,6.3-16.8c-1-4.3-3.6-7.3-6.7-8.2 c-3.1-0.9-8.4-2.2-10.1-2.7c-1.7-0.5-3.5-0.3-5.3,0.6c-5.1,2.6-7.9,10.1-6.3,16.8c1,4.4,3.6,7.3,6.7,8.2 C319.8,428.4,324.7,429.8,327.4,430.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M320.7,422.2c-1.6-6.7,1.2-14.3,6.3-16.8c1.8-0.9,3.6-1.1,5.3-0.6c-3.1-0.9-8.4-2.2-10.1-2.7 c-1.7-0.5-3.5-0.3-5.3,0.6c-5.1,2.6-7.9,10.1-6.3,16.8c1,4.4,3.6,7.3,6.7,8.2c2.5,0.7,7.4,2.1,10.1,2.7 C324.3,429.5,321.7,426.6,320.7,422.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "307.7,425.6 326.1,415.7 342.6,413.2 336.6,398.7 307.2,400.3  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "147.5,425.6 260.6,455.9 349,404.9 349,58.5 235.9,28.2 147.5,79.2  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "260.6,109.5 260.6,455.9 147.5,425.6 147.5,79.2  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5,104.1v10c0,1.7-1.6,2.9-3.2,2.5l-45.8-12.3l0-16.8l45.7,12.2C195.2,100.3,196.5,102.1,196.5,104.1z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "189.7,103.4 189.7,110.7 172,106 172,98.7  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "260.6,109.5 349,58.5 235.9,28.2 147.5,79.2  "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "147.5,139.8 260.6,170.2 269.4,165.1 269.4,450.9  "
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M279,145.4l-8.6,5V117l8.6-5V145.4z M291.3,105.1l-8.6,5v33.4l8.6-5V105.1z M303.5,98l-8.6,5v33.4l8.6-5 V98z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 268.5,
    y1: 120.3,
    x2: 307.4,
    y2: 98
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 268.5,
    y1: 127.6,
    x2: 307.4,
    y2: 105.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 268.5,
    y1: 134.9,
    x2: 307.4,
    y2: 112.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 268.5,
    y1: 142.3,
    x2: 307.4,
    y2: 120
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 268.5,
    y1: 149.6,
    x2: 307.4,
    y2: 127.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 170.3,
    y1: 10.4,
    x2: 170.3,
    y2: 627.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 273,
    y1: -14.8,
    x2: 273,
    y2: 602.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 340.1,
    y1: -53.4,
    x2: 340.1,
    y2: 563.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -46.7,
    y1: 227.6,
    x2: 544.7,
    y2: -113.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 15.3,
    y1: 323.4,
    x2: 606.7,
    y2: -18
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 60.8,
    y1: 246.1,
    x2: 652.2,
    y2: -95.3
  })), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -529.7,
    y1: -148.2,
    x2: 1310.5,
    y2: 344.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -762.5,
    y1: -96.6,
    x2: 1077.7,
    y2: 396.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -21.2,
    y1: 474.6,
    x2: 570.2,
    y2: 133.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 103.7,
    y1: 526.2,
    x2: 695.1,
    y2: 184.8
  })), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -762.4,
    y1: 161.3,
    x2: 1077.9,
    y2: 654.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -749.7,
    y1: -144.3,
    x2: 1090.5,
    y2: 348.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: -762.5,
    y1: 33.5,
    x2: 1077.7,
    y2: 526.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelfieldSpecLine);
export default __webpack_public_path__ + "static/media/Delfield-SpecLine.91e16008c1a6f008577f3d5837728f97.svg";
export { ForwardRef as ReactComponent };